import { render, staticRenderFns } from "./CatteriesList.vue?vue&type=template&id=06978b7d&scoped=true"
import script from "./CatteriesList.vue?vue&type=script&lang=js"
export * from "./CatteriesList.vue?vue&type=script&lang=js"
import style0 from "./CatteriesList.vue?vue&type=style&index=0&id=06978b7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06978b7d",
  null
  
)

export default component.exports